import styled from 'styled-components';
import { colors, dimensions } from 'modules/common/styles';

const imageSize = 30;

const Members = styled.div`
  padding-top: ${dimensions.unitSpacing - 5}px;
`;

const MemberImg = styled.img`
  width: ${imageSize}px;
  height: ${imageSize}px;
  border-radius: ${imageSize / 2}px;
  background: ${colors.bgActive};
  border: 2px solid ${colors.colorWhite};
  margin-left: -8px;

  &:first-child {
    margin-left: 0;
  }
`;

const DataWrapperClass = styled.div`
  // height: 100%;
  height: ${(props) => props.height || 100}%;
  // overflow: hidden;
  // overflow: ${(props) => props.overflow==='nohide'?"" : 'hidden'};
  overflow: ${(props)=> {
    if(props.overflow==='nohide'){ return ''}
    if(props.overflow==='auto'){ return 'auto'}
    else{ return 'hidden'}
  }}
  section.sc-iELTvK.dgWnOn {
    background: #fff;
    margin-left: 20px;
    margin-right: 20px;
  }
  section.sc-jtRfpW.daxgFZ {
    margin-right: 20px;
  }
  section.sc-iELTvK.dstvIj {
    background: #fff;
    margin-left: 20px;
  }

  .caret {
    display: none;
  }

  .drp li a {
    font-size: 11px;
    padding: 3px 12px;
  }

  .drp button {
    border: none;
    background: transparent !important;
    box-shadow: none !important;
  }

  .drp button a {
    font-size: 16px;
    color: #888;
  }
`;

const More = MemberImg.withComponent('span').extend`
  color: ${colors.colorWhite};
  text-align: center;
  vertical-align: middle;
  font-size: ${dimensions.unitSpacing}px;
  background: ${colors.colorCoreLightGray};
  display: inline-block;
  line-height: ${dimensions.coreSpacing + 6}px;
  cursor: pointer;
`;

const SectionHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const SectionTitle = styled.div`
  flex: 1;
  cursor: pointer;
  // padding: 6px ${dimensions.coreSpacing}px;
  font-size: 12px;
  span {
    display: block;
    font-size: 12px;
    color: ${colors.colorCoreGray};
  }
`;

const UserAvatar = styled.td`
  text-align: center;
  &:hover {
    cursor: pointer;
  }
`;

export {
  MemberImg,
  Members,
  More,
  DataWrapperClass,
  SectionHead,
  SectionTitle,
  UserAvatar
};



// WEBPACK FOOTER //
// src/modules/screens/settings/ContactListPrivate/styles.js